
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from './contact-us.service';
import { Location } from '@angular/common';
import { ContactUsState, FormState, SectionBottomSelect, SubMenu, SubReasonIndividualLabelData, SubReasonLabel, SubReasonLables, UserData } from './definitions';
import { ToastrService } from 'ngx-toastr';
import { countries, Icons, provinces, states } from '../../services/shared/shared-enums';
import { MainEntryService, MainEntryState } from '../main-entry';
import { Subscription } from 'rxjs';
import { KngLoaderState } from 'kinetic-angular';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { ContactUsFactory } from './contact-us.factory';
import { SharedService } from '../../services/shared/shared.service';

@Component({
	selector: 'tmhna-portal-contact-us',
	templateUrl: './template/contact-us.component.html',
	styleUrls: ['./template/contact-us.component.scss']
})
export class ContactUsComponent implements OnInit
{
	isOpen: boolean = false;
	userForm: FormGroup;
	countries= countries;
	arrowRight: string | undefined = Icons.arrowRight;
	arrowDownOrange: string | undefined = Icons.arrowDown;
	arrowLeft: string | undefined = Icons.leftArrow;
	states: { [key: string]: {label: string; value: string}[] } = {
		USA: states,
		CAN: provinces
	};
	selectedMainReason: string = '';
	selectedSubReason: string = '';
	selectedReason: string = '';
	subReasonLables: SubReasonIndividualLabelData = SubReasonLables;
	loaderState: KngLoaderState = {
  	imagePath: Icons.loaderWhite
	};
	isMobileView = false;
	isScrollHappend: boolean = false;
	get state(): ContactUsState
	{
		return this.service.state;
	}
	deviceBasedDropDownData: SectionBottomSelect []=[];
	displayReasonInput: boolean = false;
	metaData: UserData = ContactUsFactory.buildContactData();
	private readonly subscriptions: Subscription = new Subscription();
	@Input() set mainState(value: MainEntryState)
	{
		this.mainEntryservice.updateState(value);
	}
	get mainState(): MainEntryState
	{
		return this.mainEntryservice.state;
	}
	filteredStates: {label: string; value: string}[] = [];

	constructor(private readonly mainEntryservice: MainEntryService, private readonly fb: FormBuilder, public service: ContactUsService, private readonly sharedUtilService: SharedUtilService,  public location: Location, public toaster: ToastrService, public sharedService: SharedService)
	{
  	this.userForm = this.fb.group({
  		firstName: [ '', [Validators.required] ],
  		lastName: [ '', [Validators.required] ],
  		email: [ '', [ Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) ] ],
  		phone: [ '', [ Validators.required, this.sharedService.validateStringUnique, this.sharedService.validatePhoneSequence, this.sharedService.minLength ] ],
  		companyName: [ '', [Validators.required] ],
  		address: [''],
  		city: [''],
  		state: [''],
  		zipCode: [''],
  		country: [ '', [Validators.required] ],
  		reason: [ '', [Validators.required] ],
  		reasonInput: [''],
  		comments: [ '', [Validators.required] ]
  	});
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public numbersOnlyValidator(event: any)
	{
		this.userForm.patchValue({
			phone: this.sharedService.formatPhoneNumber(event.target.value)
		});
	}

	ngOnInit(): void
	{
		this.service.getContactUsState();
		this.userForm.get(FormState.country)?.valueChanges.subscribe(value =>
		{
			this.updateStateOptions(value);
		});

		this.userForm.valueChanges.subscribe(() =>
		{
			if (this.userForm.valid)
			{
				this.state.buttons.submit.disabled = false;
			}
			else
			{
				this.state.buttons.submit.disabled = true;
			}
		});
		this.mainEntryservice.getLandingPageAemLabels();
		this.subscriptions.add(this.service.stateChanged.subscribe(() =>
		{
			this.deviceBasedDropDownData = this.state.sectionBottom.dropDownData;
		}));
		const queryParams = localStorage.getItem('queryData');
		if( queryParams !== null && queryParams !== 'undefined' )
		{
			this.state.loading = true;
			this.metaData = JSON.parse(atob(queryParams));

			if(this.metaData.email)
			{
				this.service.getContactFormData(this.metaData.email);
				this.service.contactFormData$.subscribe((responseObj)=>
				{
					this.userForm.patchValue({
						firstName: this.checkNavValue(this.metaData.firstName, responseObj.firstName),
						lastName: this.checkNavValue(this.metaData.lastName, responseObj.lastName),
						country: this.checkNavValue(this.metaData.country, responseObj.country),
						address: this.checkNavValue(this.metaData.addressLine1, responseObj.addressLine1),
						zipCode: this.checkNavValue(this.metaData.zipCode, responseObj.zipCode),
						city: this.checkNavValue(this.metaData.city, responseObj.city),
						state: this.checkNavValue(this.metaData.state, responseObj.state),
						companyName: this.checkNavValue(this.metaData.companyName, responseObj.companyName),
						email: this.metaData.email,
						phone: this.sharedService.formatPhoneNumber(this.checkNavValue(this.metaData.phoneNumber, responseObj.phoneNumber))
					  });
					  this.disableFormValue();
				});
			}
			
		};
		this.isMobileView = this.sharedUtilService.updateIsMobileView();
	}
	checkNavValue(navValue: string = '', respValue: string = '')
	{
		return navValue || respValue;
	}
	disableFormValue()
	{
	   const formFields = [ FormState.firstName, FormState.lastName, FormState.email ];
	   formFields.forEach((field)=>
		{
			this.userForm.get(field)?.value ? this.userForm.controls[field].disable() : this.userForm.controls[field].enable();
		});
	}

	updateStateOptions(country: string): void
	{
  	this.filteredStates = this.states[country] || [];
  	this.userForm.get(FormState.state)?.enable();
  	this.userForm.get(FormState.state)?.setValue('');
  	if (!country)
  	{
  		this.userForm.get(FormState.state)?.disable();
  	}
	}
	toggleMenu()
	{
  	this.isOpen = !this.isOpen;
  	this.state.sectionBottom.dropDownData.forEach(dropDown =>
  	{
  		dropDown.isOpen = false;
  	});
  	this.deviceBasedDropDownData = this.state.sectionBottom.dropDownData;
	}

	toggleSubMenu(dropDownitem : SectionBottomSelect, clickFlag: boolean): void
	{
  	this.state.sectionBottom.dropDownData.forEach(dropDown =>
  	{
  		if (dropDown.label !== dropDownitem.label)
  		{
  			dropDown.isOpen = false;
  		}
  	});
  	this.selectedMainReason = dropDownitem.label;

  	this.selectedSubReason = '';
  	this.userForm.get(FormState.reason)?.setValue(this.selectedMainReason);
  	if(dropDownitem.subMenu.length !== 0)
  	{
  		this.setDeviceBasedFuntionality(dropDownitem);
  		dropDownitem.isOpen = !dropDownitem.isOpen;
  	}
  	else
  	{
  		this.displayReasonInput = false;
  		this.selectedReason = this.selectedMainReason;
  		this.subReasonLables = this.specificInputFunction('');
  		this.setDeviceBasedFuntionality(dropDownitem);
  		if(clickFlag)
  		{
  			this.isOpen = false;
  		}
  	}
	}

	setDeviceBasedFuntionality(dropDownitem : SectionBottomSelect)
	{
  	if(this.isMobileView && !dropDownitem.isOpen)
  	{
  		this.deviceBasedDropDownData = this.state.sectionBottom.dropDownData.filter(dropDown => dropDown.label === dropDownitem.label);
  	}
  	else
  	{
  		this.deviceBasedDropDownData = this.state.sectionBottom.dropDownData;
  	}
	}


	selectSubmenu(sub : SubMenu)
	{
  	this.selectedSubReason = sub.label;
	  this.selectedReason = this.selectedMainReason + ', ' + this.selectedSubReason ;
  	this.userForm.get(FormState.reason)?.setValue(this.selectedReason);
  	this.subReasonLables = this.specificInputFunction(sub.label);
  	this.isOpen = false;
  	this.deviceBasedDropDownData = this.state.sectionBottom.dropDownData;
  	if (this.subReasonLables.label === '')
  	{
  		this.displayReasonInput = false;
  	}
  	else
  	{
  		this.displayReasonInput = true;
  	}
	}


	onSubmit(): void
	{
  	if (this.userForm.valid)
  	{
  		const formData = {
				subject: this.userForm.get(FormState.reason)?.value,
				description: this.userForm.get(FormState.comments)?.value,
				requestorFirstName: this.userForm.get(FormState.firstName)?.value,
				requestorLastName: this.userForm.get(FormState.lastName)?.value,
				country: this.userForm.get(FormState.country)?.value,
				addressLine1: this.userForm.get(FormState.address)?.value,
				zipCode: (this.userForm.get(FormState.zipCode)?.value),
				city: this.userForm.get(FormState.city)?.value,
				state: this.userForm.get(FormState.state)?.value,
				companyName: this.userForm.get(FormState.companyName)?.value,
				email: this.userForm.get(FormState.email)?.value,
				phone: this.userForm.get(FormState.phone)?.value.replace(/[^\d]/g, ''),
				roleOfUser: this.checkNavValue(this.metaData.role, this.service.contactFormData.role),
				primaryLocationGRID: this.checkNavValue(this.metaData.primaryLocationGRID, this.service.contactFormData.primaryLocationGRID),
				adminLocationGRID: this.checkNavValue(this.metaData.adminLocationID, this.service.contactFormData.adminLocationID),
				crmRecordExists: (this.metaData.crmRecordExists || this.service.contactFormData.crmRecordExists || false).toString(),	
				customerType: this.metaData.customerType ?? this.service.contactFormData.customerType,
				urlOfOrigin: this.checkNavValue(this.metaData.urlOfOrigin, ''),
				accountType: this.checkNavValue(this.metaData.accountType, this.service.contactFormData.accountType)
  		};

			this.service.contactUsTicket(formData);
			if(this.metaData.urlOfOrigin)
			{
				this.userForm.controls['comments'].reset();
				this.userForm.controls['reason'].reset();
			}
			else
			{
				this.userForm.reset();
			}
  		this.selectedReason = '';
  		this.displayReasonInput = false;
  	}
  	else
  	{
  		this.toaster.error(this.state.toasterFailure.label);
  	}
	}

	onScroll(): void
	{

  	const scrollPosition = document.getElementsByClassName('dropdown-options-container');
  	if (scrollPosition[0].scrollTop > 0)
  	{
  		this.isScrollHappend = true;
  	}
  	else
  	{
  		this.isScrollHappend = false;
  	}
	}

	onCancel(): void
	{
  	this.location.back();
	}

	specificInputFunction(subReason : string): SubReasonIndividualLabelData
	{
  		switch (subReason)
  		{
  		case SubReasonLabel.partsOrder:
  			return this.state.subreasonLabelData.partsOrder[0];
  		case SubReasonLabel.equipmentOrder:
  			return this.state.subreasonLabelData.equipmentOrder[0];
  		case SubReasonLabel.manualInformation:
  			return this.state.subreasonLabelData.manualInformation[0];
  		case SubReasonLabel.partInformation:
  			return this.state.subreasonLabelData.partInformation[0];
  		}
  		return this.extraInputCheck(subReason);
	}
	extraInputCheck(subReason: string): SubReasonIndividualLabelData
	{
  	switch (subReason)
  	{
  	case SubReasonLabel.invoiceNumber:
  		return this.state.subreasonLabelData.invoiceNumber[0];
  	case SubReasonLabel.myToyotaStoreEquipmentOrder:
  		return this.state.subreasonLabelData.myToyotaStoreEquipmentOrder[0];
  	case SubReasonLabel.toyotaDealerEquipmentOrder:
  		return this.state.subreasonLabelData.toyotaDealerEquipmentOrder[0];
  	}
  	return { label: '', placeholder: '' };
	}

}
